export default __webpack_public_path__ + "static/media/introduction.7b95363c.mp4";